// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
export type BoundOptionPricingConfigFields_OptionPricingConfigFragment = { __typename?: 'OptionPricingConfig', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > }> };

export type BoundOptionPricingConfigFields_OptionPricingConfigVariantFragment = { __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export const BoundOptionPricingConfigFields_OptionPricingConfigVariantFragmentDoc = gql`
    fragment BoundOptionPricingConfigFields_OptionPricingConfigVariant on OptionPricingConfigVariant {
  id
  preCutoffDesiredMarginInBasisPoints
  postCutoffDesiredMarginInBasisPoints
  selectionFeeInCents
  minimumPriceInCents
  reasonNote
  projects {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const BoundOptionPricingConfigFields_OptionPricingConfigFragmentDoc = gql`
    fragment BoundOptionPricingConfigFields_OptionPricingConfig on OptionPricingConfig {
  id
  preCutoffDesiredMarginInBasisPoints
  postCutoffDesiredMarginInBasisPoints
  selectionFeeInCents
  minimumPriceInCents
  reasonNote
  variants {
    ...BoundOptionPricingConfigFields_OptionPricingConfigVariant
  }
}
    ${BoundOptionPricingConfigFields_OptionPricingConfigVariantFragmentDoc}`;